import { format } from 'date-fns';
import { DateTime } from 'luxon';
import * as React from 'react';
import { useIntl } from 'react-intl';

import css from '../PurchaseItemList.module.scss';

interface OwnProps {
  productImage?: string;
  merchantId?: string;
  productName?: string;
  productUrl?: string;
  schemeType: 'subscription' | 'ticketBook';
}

type Props = OwnProps;

const PurchaseItemProfile = (props: Props) => {
  const publishedAt = DateTime.local().toString();
  const intl = useIntl();

  return (
    <span>
      {props.productUrl ? (
        <a className={css.PurchaseItemList__Link} href={props.productUrl}>
          <div className={css.PurchaseItemList__Inner}>
            {props.productImage ? (
              <img
                className={css.PurchaseItemList__Image}
                src={props.productImage}
                alt={props.productName}
              />
            ) : (
              <span className={css.PurchaseItemList__Image} />
            )}
            <p className={css.PurchaseItemList__Name}>
              {props.productName}
              <span className={css.PurchaseItemList__Id}>
                {props.merchantId}
              </span>
            </p>
            {props.schemeType === 'subscription' && (
              <p className={css.PurchaseItemList__AdmissionDate}>
                {intl.formatMessage({ id: 'common.dateOfSubscription' })}：
                {intl.formatDate(format(publishedAt), {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  weekday: 'short',
                })}
              </p>
            )}
          </div>
        </a>
      ) : (
        <div className={css.PurchaseItemList__Inner}>
          {props.productImage ? (
            <img
              className={css.PurchaseItemList__Image}
              src={props.productImage}
              alt={props.productName}
            />
          ) : (
            <span className={css.PurchaseItemList__Image} />
          )}
          <div>
            <p className={css.PurchaseItemList__Name}>
              {props.productName}
              <span className={css.PurchaseItemList__Id}>
                {props.merchantId}
              </span>
            </p>
            {props.schemeType === 'subscription' && (
              <p className={css.PurchaseItemList__AdmissionDate}>
                {intl.formatMessage({ id: 'common.dateOfSubscription' })}：
                {intl.formatDate(format(publishedAt), {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  weekday: 'short',
                })}
              </p>
            )}
          </div>
        </div>
      )}
    </span>
  );
};

export default PurchaseItemProfile;
